export async function AdvisorExchangeCodeToken(code, redirect_uri) {

    const raw = JSON.stringify({
        code: code,
        redirect_uri: redirect_uri,
    });

    const requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: {"Content-Type": "application/json"},
    };

    try {
        const response = await fetch(
            process.env.REACT_APP_ADVISOR_EXCHANGE_CODE_TOKEN_API,
            requestOptions
        );

        const message = await response.json();

        if (!response.ok) {
            return { status: response.status, error: message.error || message };
        } else {
            return { status: response.status, result: message.result };
        }
    } catch (error) {
        return { status: 0, error: error.message };
    }
}
